// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__NuMLq","footer":"ReportModalFilter_footer__2-KJo"};